import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ModalChange } from 'src/core/types/modal.types';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  $modalChanged: BehaviorSubject<ModalChange> = new BehaviorSubject<ModalChange>({modal:"autocheck",open:false});
  $helpModalChanged: BehaviorSubject<ModalChange> = new BehaviorSubject<ModalChange>({modal:"autocheck",open:false});

  constructor() { }


}